import { format } from 'date-fns'

/**
 * 与えられた日時をISO8601拡張形式の日付に変換して返す
 * 計算は実行環境のタイムゾーンにもとづき行われる。
 */
export const toDateString = (date: Date) => {
  return format(date, 'yyyy-MM-dd')
}
